import { useMemo, useState } from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import SiteShell from "../components/SiteShell";

const office = {
  name: "Finn Cube",
  address: "9th Floor, 954/AB, JMD Megapolis, Sohna Road, Gurugram, Haryana,122018",
  lat: 28.41938,
  lng: 77.038,
};

const kioskLocations = [
  {
    city: "Gurugram",
    name: "JMD Regent Square",
    address:
      "Mehrauli-Gurgaon Rd, DLF Phase 2, Sector 25, Gurugram, Sarhol, Haryana 122001",
  },
  {
    city: "Gurugram",
    name: "JMD Megapolis",
    address: "Badshahpur Sohna Rd, Sector 48, Gurugram, Haryana 122018",
  },
  {
    city: "Gurugram",
    name: "MGF Metropolitan",
    address:
      "Mehrauli-Gurgaon Rd, Heritage City, Sector 25, Gurugram, Haryana 122009",
  },
  {
    city: "Gurugram",
    name: "Unitech Cyber Park - Tower - A",
    address: "Durga Colony, Sector 39, Gurugram, Haryana 122003",
  },
  {
    city: "Gurugram",
    name: "Unitech Cyber Park - Tower - B & C",
    address: "Durga Colony, Sector 39, Gurugram, Haryana 122003",
  },
  {
    city: "Gurugram",
    name: "Unitech Business Park - Tower - B",
    address: "Sector 17-B, Block F, South City I, Sector 41, Gurugram, Haryana 122003",
  },
  {
    city: "Gurugram",
    name: "Unitech Signature Tower",
    address: "South City I, Sector 30, Gurugram, Haryana 122001",
  },
  {
    city: "Gurugram",
    name: "Udyog Vihar - Nimitiya-108",
    address:
      "108, Udyog Vihar Phase 1, Udyog Vihar, Sector 20, Gurugram, Haryana 122016",
  },
  {
    city: "Noida",
    name: "Windsor IT Park-Sec-125",
    address: "Plot No. 5, Sector 142, Noida, Uttar Pradesh 201304",
  },
  {
    city: "Noida",
    name: "Windsor Grand-Sec-126",
    address: "Plot number, 1- C, Raipur Khadar, Sector 126, Noida, Uttar Pradesh 201313",
  },
  {
    city: "Delhi - NSP",
    name: "D Mall",
    address: "123, Wazirpur Flyover, Netaji Subhash Place, Pitampura, New Delhi 110034",
  },
];

function getGoogleMapsUrl(location) {
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    `${location.name}, ${location.address}`,
  )}&travelmode=driving`;
}

function getDistanceInKm(lat1, lng1, lat2, lng2) {
  const toRad = (v) => (v * Math.PI) / 180;
  const earthRadius = 6371;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
    Math.cos(toRad(lat2)) *
    Math.sin(dLng / 2) *
    Math.sin(dLng / 2);
  return earthRadius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function Locate() {
  const [userPosition, setUserPosition] = useState(null);
  const [status, setStatus] = useState("");

  const mapUrl = useMemo(() => {
    const q = encodeURIComponent(office.address);
    return `https://www.google.com/maps?q=${q}&z=15&output=embed`;
  }, []);

  const routeUrl = useMemo(() => {
    const destination = encodeURIComponent(office.address);
    if (userPosition) {
      return `https://www.google.com/maps/dir/?api=1&origin=${userPosition.lat},${userPosition.lng}&destination=${destination}&travelmode=driving`;
    }
    return `https://www.google.com/maps/dir/?api=1&destination=${destination}&travelmode=driving`;
  }, [userPosition]);

  const distance = useMemo(() => {
    if (!userPosition) return null;
    return getDistanceInKm(
      userPosition.lat,
      userPosition.lng,
      office.lat,
      office.lng,
    ).toFixed(1);
  }, [userPosition]);

  const handleLocateUs = () => {
    if (!navigator.geolocation) {
      setStatus("Geolocation is not supported in this browser.");
      return;
    }

    setStatus("Fetching your current location...");
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setUserPosition({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        setStatus("Location found. You can now check your route.");
      },
      () => {
        setStatus("Unable to get your location. Please allow location access.");
      },
      { enableHighAccuracy: true, timeout: 10000 },
    );
  };

  return (
    <SiteShell
      route="locate"
      heroTag="Visit Us"
      heroTitle="Locate Us"
      heroText="Find our office quickly, detect your current location, and check your best route in one click."
      heroImage="/team_premium_office_1772861377531.png"
      heroActions={[
        {
          label: "Locate Us",
          href: "https://locations-page-ubwe.vercel.app/",
          primary: true,
        },
      ]}
      heroHighlights={[
        { label: "Office", value: "Gurugram HQ" },
        { label: "State", value: "Haryana" },
        { label: "Support", value: "Mon-Sat" },
        { label: "Route", value: "Google Maps" },
      ]}
    >
      <section className="mx-auto max-w-[1280px] px-6 py-14 md:px-10">
        <div className="grid gap-8 rounded-3xl border border-slate-200 bg-white p-6 shadow-lg lg:grid-cols-[1.2fr_0.8fr]">
          <div className="overflow-hidden rounded-2xl border border-slate-200">
            <iframe
              title="Bharat Digital Office Location"
              src={mapUrl}
              className="h-[430px] w-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          <div className="rounded-2xl bg-slate-50 p-6">
            <p className="text-[15px] font-black uppercase tracking-[0.2em] text-[#e37921]">
              Locate Us
            </p>
            <h2 className="mt-3 text-2xl font-extrabold text-[#0a2c4f]">
              {office.name}
            </h2>
            <p className="mt-2 text-sm text-slate-600">{office.address}</p>

            <div className="mt-6 space-y-3">
              <button
                type="button"
                onClick={handleLocateUs}
                className="w-full rounded-full bg-[#e37921] px-5 py-3 text-xs font-black uppercase tracking-[0.15em] text-white transition hover:bg-[#e37921]"
              >
                Locate Us
              </button>
              <a
                href={routeUrl}
                target="_blank"
                rel="noreferrer"
                className="block w-full rounded-full border border-[#0a2c4f] px-5 py-3 text-center text-xs font-black uppercase tracking-[0.15em] text-[#0a2c4f] transition hover:bg-[#0a2c4f] hover:text-white"
              >
                Check Route
              </a>
            </div>

            {status ? (
              <p className="mt-4 text-sm font-semibold text-slate-700">{status}</p>
            ) : null}

            {distance ? (
              <p className="mt-2 text-sm text-slate-600">
                Approx distance to office:{" "}
                <span className="font-bold text-[#0a2c4f]">{distance} km</span>
              </p>
            ) : null}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-6 pb-16 md:px-10">
        <div className="mb-8 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            {/* <p className="text-[15px] font-black uppercase tracking-[0.2em] text-[#e37921]">
              Kiosk Locations
            </p> */}
            <h2 className="mt-3 text-3xl font-extrabold tracking-tight text-[#0a2c4f] md:text-4xl">
              Find FinnCube Near You
            </h2>
          </div>
          {/* <p className="max-w-md text-sm leading-relaxed text-slate-500">
            Select any address to open the exact location in Google Maps.
          </p> */}
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {kioskLocations.map((location, index) => (
            <a
              key={`${location.name}-${index}`}
              href={getGoogleMapsUrl(location)}
              target="_blank"
              rel="noreferrer"
              className="group flex min-h-[190px] flex-col rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition hover:-translate-y-1 hover:border-[#e37921] hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-[#e37921]"
              aria-label={`Open ${location.name} in Google Maps`}
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <p className="text-xs font-black uppercase tracking-[0.18em] text-[#e37921]">
                    {location.city}
                  </p>
                  <h3 className="mt-2 text-lg font-extrabold leading-snug text-[#0a2c4f]">
                    {location.name}
                  </h3>
                </div>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-slate-100 text-[#0a2c4f] transition group-hover:bg-[#e37921] group-hover:text-white">
                  <FaMapMarkerAlt aria-hidden="true" />
                </span>
              </div>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-slate-600">
                {location.address}
              </p>
              <span className="mt-5 text-xs font-black uppercase tracking-[0.15em] text-[#0a2c4f] transition group-hover:text-[#e37921]">
                Open in Google Maps
              </span>
            </a>
          ))}
        </div>
      </section>

      <h2 className="text-3xl ml-20 font-extrabold tracking-tight text-[#0a2c4f] md:text-4xl pb-20">Contact Us</h2>

      <section
        id="career-openings"
        className="mx-auto max-w-[1280px] px-6 pb-24 md:px-10"
      >
        <div className="grid overflow-hidden rounded-[32px] shadow-xl md:grid-cols-2">

          {/* LEFT SIDE */}
          <div className="bg-[#0a2c4f] p-10 text-white md:p-14">
            <h2 className="text-4xl font-extrabold leading-tight">
              Let's build smarter <br />
              financial operations <br />
              together.
            </h2>

            <div className="mt-12 space-y-10">

              {/* Office Section */}
              <div>
                <p className="text-lg font-bold">Our Office:</p>

                <div className="mt-4 space-y-6 text-sm text-white/80">

                  <div>
                    <p className="font-bold text-white">Delhi NCR</p>
                    <p>
                      9th Floor, 954/AB, JMD Megapolis, Sohna Road, Gurugram, Haryana,122018
                    </p>
                  </div>

                </div>
              </div>

              {/* Email */}
              <div>
                <p className="text-lg font-bold">Email:</p>
                <p className="text-white/80">care@finncube.com</p>
              </div>

              {/*Phone No.*/}
              <div>
                <p className="text-lg font-bold">Phone No.</p>
                <p className="text-white/80">+91 8510014401</p>
              </div>

            </div>
          </div>

          {/* RIGHT SIDE FORM */}
          <div className="bg-white p-10 md:p-14">
            <h2 className="text-3xl font-extrabold text-[#0a2c4f]">
              Get In Touch
            </h2>

            <p className="mt-3 text-sm text-slate-500">
              Drop your details and our team will connect with a solution
              tailored for your institution.
            </p>

            <form
              action="mailto:care@finncube.com"
              method="POST"
              encType="multipart/form-data"
              className="mt-8 space-y-5"
            >

              {/* Name + Email */}
              <div className="grid gap-4 md:grid-cols-2">

                <input
                  type="text"
                  name="name"
                  required
                  placeholder="Your Name"
                  className="rounded-xl border border-slate-200 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#e37921]"
                />

                <input
                  type="email"
                  name="email"
                  required
                  placeholder="Your Email"
                  className="rounded-xl border border-slate-200 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#e37921]"
                />

              </div>

              {/* Subject */}
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                className="w-full rounded-xl border border-slate-200 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#e37921]"
              />

              {/* Message */}
              <textarea
                name="message"
                rows="6"
                placeholder="Message"
                className="w-full rounded-xl border border-slate-200 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#e37921]"
              />

              {/* Button */}
              <button
                type="submit"
                className="mt-4 rounded-full bg-[#e37921] px-10 py-3 text-sm font-bold text-white transition hover:scale-[1.03]"
              >
                Send Message
              </button>

            </form>
          </div>

        </div>
      </section>
    </SiteShell>
  );
}

export default Locate;
